export var VoucherStatus;
(function (VoucherStatus) {
    VoucherStatus["Complete"] = "complete";
    VoucherStatus["Error"] = "error";
})(VoucherStatus || (VoucherStatus = {}));
